/* eslint-disable no-unused-vars */
import { QuestionFormField, QuestionFormFieldType } from './questionFormField'

/**
 * Creates an instance of CheckboxField.
 * @typedef {Object} CheckboxFieldType
 *
 * @typedef {QuestionFormFieldType & CheckboxFieldType} CheckboxFieldExtendType
 */

/**
 * Represents a checkbox form field.
 * @class
 */
export class CheckboxField extends QuestionFormField {}
